import { render, staticRenderFns } from "./ContractHistory.vue?vue&type=template&id=80c94b76&scoped=true&"
import script from "./ContractHistory.vue?vue&type=script&lang=js&"
export * from "./ContractHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContractHistory.vue?vue&type=style&index=0&id=80c94b76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c94b76",
  null
  
)

export default component.exports